import React, { useEffect, useState } from "react";
import BaseWrapper from "../../components/ui/BaseWrapper";
import BaseDataTableV2 from "../../components/ui/BaseDataTableV2";
import BaseCheckbox from "../../components/ui/BaseCheckbox";
import { useQuery } from "@tanstack/react-query";
import { fetchUserPermissions } from "../../services/api/permissions";
import useAuth from "../../hooks/useAuth";
import { useParams } from "react-router-dom";
import BaseButton from "../../components/ui/BaseButton";
import { ModuleNames } from "../../utils/enum";
import BaseCard from "../../components/ui/BaseCard";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/toast/toastSlice";
const modules = [
  { id: "users", name: "Users" },
  { id: "work-orders", name: "Work Orders" },
  { id: "invoices", name: "Invoices" },
];

const UserPermissionsTable = () => {
  const { id: userId } = useParams();
  const dispatch = useDispatch();
  const {
    isPending: isfetchUserPermissionsApiLoading,

    data: userPermissionsData,
  } = useQuery({
    queryKey: ["permissions", userId],
    queryFn: () => fetchUserPermissions(userId),
    enabled: !!userId,
  });

  console.log("userPermissionsData,", userPermissionsData);

  const [permissions, setPermissions] = useState([]);
  const [changedPermissions, setChangedPermissions] = useState({});

  useEffect(() => {
    if (userPermissionsData?.data?.length) {
      setPermissions(userPermissionsData.data);
    }
  }, [userPermissionsData]);

  const updatePermission = (moduleId, field, value) => {
    setPermissions((prev) =>
      prev.map((row) => {
        if (row.module === moduleId) {
          // Track change if different from original
          if (row[field] !== value) {
            setChangedPermissions((prevChanges) => ({
              ...prevChanges,
              [moduleId]: {
                ...prevChanges[moduleId],
                module: moduleId,
                [field]: value,
              },
            }));
          } else {
            // Remove change if reverted back to original
            setChangedPermissions((prevChanges) => {
              const updated = { ...prevChanges };
              if (updated[moduleId]) {
                delete updated[moduleId][field];
                if (Object.keys(updated[moduleId]).length === 1) {
                  // only module key left, remove the whole row
                  delete updated[moduleId];
                }
              }
              return updated;
            });
          }
          return { ...row, [field]: value };
        }
        return row;
      })
    );
  };

  const handleSave = async () => {
    const dataToSend = Object.values(changedPermissions);
    if (dataToSend.length === 0) return;
    console.log("first,", dataToSend);
    try {
      //   await saveUserPermissions(userId, dataToSend);
      alert("Permissions saved successfully!");
      dispatch(
        showToast({
          message: "Permissions saved successfully",
          type: "success",
        })
      );
      setChangedPermissions({});
    } catch (err) {
      console.error(err);
      alert("Failed to save permissions.");
    }
  };

  const columns = [
    {
      field: "module",
      headerName: "Module",
      flex: 2,
      renderCell: (params) => (
        <p>{ModuleNames[params.row.module] || params.row.module}</p>
      ),
    },
    {
      field: "isWrite",
      headerName: "Create",
      flex: 1,
      renderCell: (params) => (
        <BaseCheckbox
          color="#FF5F00"
          checked={params.row.isWrite}
          onChange={(e) =>
            updatePermission(params.row.module, "isWrite", e.target.checked)
          }
        />
      ),
    },
    {
      field: "isUpdate",
      headerName: "Edit",
      flex: 1,
      renderCell: (params) => (
        <BaseCheckbox
          color="#FF5F00"
          checked={params.row.isUpdate}
          onChange={(e) =>
            updatePermission(params.row.module, "isUpdate", e.target.checked)
          }
        />
      ),
    },
    {
      field: "isRead",
      headerName: "View",
      flex: 1,
      renderCell: (params) => (
        <BaseCheckbox
          color="#FF5F00"
          checked={params.row.isRead}
          onChange={(e) =>
            updatePermission(params.row.module, "isRead", e.target.checked)
          }
        />
      ),
    },
    {
      field: "isDelete",
      headerName: "Delete",
      flex: 1,
      renderCell: (params) => (
        <BaseCheckbox
          color="#FF5F00"
          checked={params.row.isDelete}
          onChange={(e) =>
            updatePermission(params.row.module, "isDelete", e.target.checked)
          }
        />
      ),
    },
  ];

  console.log("permission", permissions);
  return (
    <BaseWrapper className="!mx-0">
      <BaseCard className="p-[10px] flex justify-end">
        <BaseButton
          color="primary"
          className="px-[6px] py-[4px]"
          onClick={handleSave}
          disabled={Object.keys(changedPermissions).length === 0}
        >
          Save Changes
        </BaseButton>
      </BaseCard>
      <div className="mt-2">
          <BaseDataTableV2
            className="max-h-[calc(100vh-300px)]"
            rowHeight={38}
            columns={columns}
            data={permissions}
            isLoading={isfetchUserPermissionsApiLoading}
            disableColumnResize={false}
            hideFooter={true}
            disableRowSelectionOnClick
            getRowId={(row) => row.module}
            // checkboxSelection
          />
      </div>
    </BaseWrapper>
  );
};

export default UserPermissionsTable;
